import React, { useCallback, useMemo } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { dateMiladiToShamsi } from "common/method/date";
import {
  getUnitStringFromMaxVal,
  getvalueRefomated,
} from "common/method/displayData";
import { useEffect, useState } from "react";
import { MdKeyboardArrowUp } from "react-icons/md";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Modals from "./components/tableCustom/modals";
import RiskChart from "./firstRow/riskChart/index";
import AnimatedBox from "common/animations";

const initialState = {
  isOpen: false,
  type: "",
};
const Card = styled.div`
  // margin: 10px 10px;
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export default function Index() {
  const [modalState, setModalState] = useState(initialState);

  const handleOpenModal = (type) => {
    setModalState({
      isOpen: true,
      type: type,
    });
  };

  const handleCloseModal = () => {
    setModalState(initialState);
  };

  const [invited, setInvited] = useState("-");
  const [portfo, setPortfo] = useState({
    total: 0,
    dailyReturn: 0,
  });

  const LastDetailsReducer = useSelector(
    (state) => state.select_last_portfolio_detail_reducer
  );
  const totalAssets = useMemo(() => {
    return (
      LastDetailsReducer?.data
        ?.filter((item) => item?.body?.quantity > 0)
        ?.map((item) => item?.body?.total_value) || []
    );
  }, [LastDetailsReducer?.data]);

  const sumTotalAssets = useMemo(() => {
    return totalAssets.reduce((acc, val) => acc + val, 0);
  }, [totalAssets]);

  const totalObligations = useMemo(() => {
    return (
      LastDetailsReducer?.data
        ?.filter((item) => item?.body?.quantity < 0)
        ?.map((item) => item?.body?.total_value) || []
    );
  }, [LastDetailsReducer?.data]);

  const sumTotalObligations = useMemo(() => {
    return totalObligations.reduce((acc, val) => acc + val, 0);
  }, [totalObligations]);

  const clubmemberSelect = useSelector((state) => state.clubmember_Select);
  // const reducerPortfolio = useSelector(state => state.select_portfolio_reducer)
  const reducerLivePortfolio = useSelector(
    (state) => state.select_live_portfolio_reducer
  );

  const handleData = useCallback((data) => {
    const remain = data.remain ? data.remain / 10 : 0;
    const debt = data?.debit_value ? data?.debit_value / 10 : 0;
    const credit = data?.credit ? data?.credit / 10 : 0;
    const total_stock_value_live = data?.total_stock_value_live
      ? data?.total_stock_value_live / 10
      : 0;

    const net_Worth = data?.net_Worth ? +data?.net_Worth : 0;
    const net_Worth_change = data?.net_Worth_change || 0;

    const returnValue = net_Worth_change
      ? (net_Worth / 10) * net_Worth_change - net_Worth / 10
      : 0;

    const relatedDate = data?.related_date
      ? dateMiladiToShamsi(data.related_date)
      : "";

    const dailyReturn = net_Worth_change ? net_Worth_change - 1 : 0;

    setPortfo({
      net_Worth,
      returnValue,
      remain,
      debt,
      total_stock_value_live,
      relatedDate,
      dailyReturn,
      credit,
    });
  }, []);

  const bgStyle = useMemo(() => {
    const dailyReturn = Number(portfo.dailyReturn);
    if (dailyReturn > 0) return { background: "#099C55", color: "#FFF" };
    if (dailyReturn < 0) return { background: "#D62D4D", color: "#FFF" };
    return {};
  }, [portfo.dailyReturn]);

  const arrowStyle = useMemo(() => {
    const dailyReturn = Number(portfo.dailyReturn);
    if (dailyReturn === 0) return { display: "none" };
    if (dailyReturn < 0) return { transform: "rotate(180deg)" };
    return {};
  }, [portfo.dailyReturn]);

  useEffect(() => {
    setInvited(clubmemberSelect?.data?.total);
  }, [clubmemberSelect]);

  useEffect(() => {
    if (Object?.keys(reducerLivePortfolio?.data)?.length) {
      handleData(reducerLivePortfolio.data);
    }
  }, [reducerLivePortfolio.data]);

  return (
    <>
      <div className="grid grid-cols-13 gap-3 md:gap-6  w-full">
        <div className="col-span-13 2xl:col-span-8 grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-6 tourguide-home-third-step">
          <AnimatedBox entry="slide-up" className="col-span-1 min-h-[145px]">
            <Card>
              <div className="py-4 px-3 lg:px-6 relative w-full h-full flex flex-col justify-between items-end">
                <div className="flex justify-between w-full">
                  <p>دعوت شده</p>
                </div>

                <div>
                  <div className="text-base font-normal text-gray-400">نفر</div>
                  <div className="font-medium text-xl">
                    {invited ? invited : "0"}
                  </div>
                </div>
              </div>
            </Card>
          </AnimatedBox>
          <div className="col-span-1 min-h-[145px]">
            <Card>
              {" "}
              <AnimatedBox
                entry="dropIn"
                className="py-4 px-3 lg:px-6 relative w-full h-full flex flex-col justify-between items-end"
              >
                <div className="flex justify-between w-full">
                  <p>قدرت خرید</p>
                  <div>
                    <InfoOutlinedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenModal("قدرت خرید")}
                    />
                  </div>
                </div>
                <div className="flex flex-col items-end">
                  <p
                    style={{ direction: "ltr" }}
                    className="text-base font-normal text-gray-400"
                  >
                    {getUnitStringFromMaxVal(
                      portfo.remain !== "NaN" ? portfo.remain : 0
                    )}
                  </p>
                  <p
                    style={{ direction: "ltr" }}
                    className="font-medium text-xl"
                  >
                    {getvalueRefomated(
                      portfo.remain
                        ? portfo.remain !== "NaN"
                          ? portfo.remain
                          : 0
                        : 0
                    )}
                  </p>
                </div>
              </AnimatedBox>
            </Card>
          </div>
          <div className="col-span-1 min-h-[145px]">
            <Card>
              {" "}
              <AnimatedBox
                entry="fadeIn"
                className="py-4 px-3 lg:px-6 relative w-full h-full flex flex-col justify-between items-end bg-[#e7ae0b] rounded-[10px] text-white"
              >
                <div className="flex justify-between w-full">
                  <p>اعتبار</p>
                  <div>
                    <InfoOutlinedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenModal("اعتبار")}
                    />
                  </div>
                </div>
                <div className="flex flex-col items-end">
                  <div className="text-base font-normal text-white">
                    {getUnitStringFromMaxVal(
                      portfo.credit
                        ? portfo.credit !== "NaN"
                          ? portfo.credit
                          : 0
                        : 0
                    )}
                  </div>
                  <div className="font-medium text-xl">
                    {getvalueRefomated(
                      portfo.credit
                        ? portfo.credit !== "NaN"
                          ? portfo.credit
                          : 0
                        : 0
                    )}
                  </div>
                </div>
              </AnimatedBox>
            </Card>
          </div>
          <div className="col-span-1 min-h-[145px]">
            <Card>
              {" "}
              {/* <div className={`py-4 px-6 relative w-full h-full flex flex-col justify-between items-end`}> */}
              <AnimatedBox
                entry="skewReveal"
                className="py-4 px-3 lg:px-6 relative w-full h-full flex flex-col justify-between items-end"
              >
                <div className="flex justify-between w-full">
                  <p>ارزش پرتفوی</p>
                  <div>
                    <InfoOutlinedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => handleOpenModal("ارزش پرتفوی")}
                    />
                  </div>
                </div>
                <div className="flex flex-col items-end">
                  <div className="text-base font-normal text-gray-400">
                    {getUnitStringFromMaxVal(
                      portfo.total_stock_value_live
                        ? portfo.total_stock_value_live !== "NaN"
                          ? portfo.total_stock_value_live
                          : 0
                        : 0
                    )}
                  </div>
                  <div className="font-medium text-xl">
                    {getvalueRefomated(
                      portfo.total_stock_value_live
                        ? portfo.total_stock_value_live !== "NaN"
                          ? portfo.total_stock_value_live
                          : 0
                        : 0
                    )}
                  </div>
                </div>
              </AnimatedBox>
            </Card>
          </div>
          <div className="col-span-2 md:col-span-1 min-h-[145px]">
            <Card>
              {" "}
              <AnimatedBox
                entry="zoom"
                className="py-4 px-3 lg:px-6 relative w-full h-full flex flex-col justify-between items-end bg-gradient-to-b from-[#2FA0E0] to-[#2A8EDE] rounded-[10px] text-white"
              >
                <div className="flex justify-between w-full">
                  <div className="flex justify-between w-full">
                    <div>
                      <p>خالص دارایی </p>
                      <span className="text-xs">
                        {!isNaN(portfo.debt)
                          ? portfo.debt === 0
                            ? "(بدون اعتبار)"
                            : ""
                          : ""}{" "}
                      </span>{" "}
                      {portfo.relatedDate}
                    </div>
                    <div>
                      <InfoOutlinedIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenModal("خالص دارایی")}
                      />{" "}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-end">
                  <div className="text-base font-normal">
                    {getUnitStringFromMaxVal(
                      portfo.net_Worth ? portfo.net_Worth / 10 : 0
                    )}
                  </div>
                  <div className="font-medium text-lg sm:text-xl">
                    {getvalueRefomated(
                      portfo.net_Worth ? portfo.net_Worth / 10 : 0
                    )}
                  </div>
                </div>
              </AnimatedBox>
            </Card>
          </div>
        </div>
        <div className="col-span-13 2xl:col-span-5 grid grid-cols-4 md:grid-cols-5 gap-3 md:gap-6">
          <div className="col-span-4 md:col-span-2 rounded-lg min-h-[145px] tourguide-home-third-step">
            <Card>
              <AnimatedBox
                entry="fadeIn"
                className={`py-4 px-3 lg:px-6 relative w-full h-full flex flex-col justify-between items-end rounded-[10px] `}
                style={bgStyle}
              >
                <div className="self-start">
                  ارزش افزوده روز {portfo.relatedDate}
                </div>
                <div className="flex flex-col items-end relative">
                  <div
                    className={`text-5xl absolute left-[-10px] top-[-35px]`}
                    style={arrowStyle}
                  >
                    <MdKeyboardArrowUp />
                  </div>
                  <div className="text-base font-normal">
                    {getUnitStringFromMaxVal(
                      portfo.returnValue ? portfo.returnValue : 0
                    )}
                  </div>
                  <div
                    className="font-medium text-xl"
                    style={{ direction: "ltr" }}
                  >
                    {getvalueRefomated(
                      portfo.returnValue ? portfo.returnValue : 0
                    )}
                  </div>
                </div>
              </AnimatedBox>
            </Card>
          </div>
          <div
            className=" col-span-4 md:col-span-3 rounded-lg min-h-[145px] tourguide-home-tenth-step"
            style={{ minWidth: 290 }}
          >
            <Card>
              <AnimatedBox
                entry="slide-down"
                className="py-4 px-3 lg:px-6 relative w-full h-full"
              >
                <RiskChart />
              </AnimatedBox>
            </Card>
          </div>
        </div>
      </div>
      <Modals
        modalState={modalState}
        handleCloseModal={handleCloseModal}
        sumTotalAssets={sumTotalAssets}
        sumTotalObligations={sumTotalObligations}
        net_Worth={portfo.net_Worth}
      />
    </>
  );
}
